module.exports = [{
      plugin: require('C:/Users/user/Documents/GitHub/prelaunch/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/user/Documents/GitHub/prelaunch/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Disruption Research","short_name":"DR","start_url":"/","background_color":"#182533","theme_color":"#182533","display":"minimal-ui","include_favicon":false,"theme_color_in_head":true,"icon":"content/assets/icon-square-blue-png.png"},
    },{
      plugin: require('C:/Users/user/Documents/GitHub/prelaunch/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/user/Documents/GitHub/prelaunch/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
